import styled from 'styled-components';

export const WrapperHeader = styled.div`

.header {
  background-color: #f42534;
}

.container {
  max-width: 829px;
}

@media (max-width: 426px){

}

@media (max-width: 375px){

}

@media (max-width: 321px){

}
`;

export default WrapperHeader;